/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityRegion } from './FacilityRegion';
import {
    FacilityRegionFromJSON,
    FacilityRegionFromJSONTyped,
    FacilityRegionToJSON,
    FacilityRegionToJSONTyped,
} from './FacilityRegion';

/**
 * 
 * @export
 * @interface CreateFacilityRegion201Response
 */
export interface CreateFacilityRegion201Response {
    /**
     * 
     */
    data?: FacilityRegion;
}

/**
 * Check if a given object implements the CreateFacilityRegion201Response interface.
 */
export function instanceOfCreateFacilityRegion201Response(value: object): value is CreateFacilityRegion201Response {
    return true;
}

export function CreateFacilityRegion201ResponseFromJSON(json: any): CreateFacilityRegion201Response {
    return CreateFacilityRegion201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityRegion201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityRegion201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FacilityRegionFromJSON(json['data']),
    };
}

export function CreateFacilityRegion201ResponseToJSON(json: any): CreateFacilityRegion201Response {
    return CreateFacilityRegion201ResponseToJSONTyped(json, false);
}

export function CreateFacilityRegion201ResponseToJSONTyped(value?: CreateFacilityRegion201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FacilityRegionToJSON(value['data']),
    };
}

